const initialState = () => ({
  clients: {},
  products: {},
});

const state = initialState();

export default state;
